import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';

@Component({
    selector: 'app-prescricption-solution-details',
    templateUrl: './prescricption-solution-details.component.html',
    styleUrls: ['./prescricption-solution-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescricptionSolutionDetailsComponent {

  constructor() { }

  @Input() prescriptionSolution: PrescriptionSolutionStruct;

  ngOnInit(): void {}
}
